//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ProductCtaButtonsMobile',
  components: {
    CtaButtons: () => import('@motionelements/product2025/src/sections/CtaButtons.vue'),
    SecondaryCtaButtons: () => import('@motionelements/product2025/src/sections/SecondaryCtaButtons.vue'),
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
};
